import React, { useState, useEffect, Suspense, lazy } from "react";
import Banner from "./components/js/Banner";
import "./components/css/common.css";
import "./components/css/variables.css";
import { Loader } from "./components/js/Loader";
import { PressReleaseComponent } from "press-release";
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import { CookieSetting } from "cookiesetting-component";
import { getSortedJsonWrtDates } from "./components/js/helpers";
const Videos = lazy(() => import("./components/js/Videos"));
const Info = lazy(() => import("./components/js/Info"));

const BestOfYoutube = lazy(() => import("./components/js/BestOfYoutube"));
const SocialMedia = lazy(() => import("./components/js/SocialMedia"));
const Favorites = lazy(() => import("./components/js/Favorites"));
const ScrollToTop = lazy(() => import("./components/js/ScrollToTop"));
const Footer = lazy(() => import("./components/FooterNew/index.js"));
const Navbar = lazy(() => import("./components/Header/index.js"));


function App() {
  const [deviceType, setDeviceType] = useState(
    window.innerWidth < 575 ? "mobile" : "desktop"
  );
  const [pressReleaseList, setPressReleaseList] = useState([]);
  const [favoriteUpdatesList, setfavoriteUpdatesList] = useState([]);

  const favoriteKeywords = ["sun west"];

  

  useEffect(() => {
    window.addEventListener("resize", () => {
      setDeviceType(window.innerWidth < 575 ? "mobile" : "desktop");
    });

    window.scrollTo(0, 0);

    if (pressReleaseList.length === 0) {
      axios.get(process.env.REACT_APP_PRESS_RELEASES).then((res) => {
        const arrayWithLatestDates = getSortedJsonWrtDates(res.data);
        setPressReleaseList(arrayWithLatestDates);
        setfavoriteUpdatesList(
          /** PMWEB-286: filter as per array keywords,
           * and show only top 2
           */
          arrayWithLatestDates
            .filter((item) => {
              let flag = false;
              favoriteKeywords.forEach((fav) => {
                if (item.title.toLowerCase().indexOf(fav) !== -1 && !flag) {
                  flag = true;
                }
              });
              return flag;
            })
            .slice(0, 2)
        );
      });
    }

    return () => {
      window.removeEventListener("resize", () => {});
    };
  }, []);
  const appVersion = appversion.version;
  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true}
      isVerboseMode={false}
      metaFileDirectory={process.env.PUBLIC_URL}
    >
    <div className="pavans-page">
        <Suspense fallback={<Loader />}>
        <Navbar />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Banner />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Info />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Favorites
          deviceType={deviceType}
          favoriteUpdatesList={favoriteUpdatesList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {/* <PressRelease
          deviceType={deviceType}
          pressReleaseList={pressReleaseList}
        /> */}
        
          <PressReleaseComponent />
       
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Videos deviceType={deviceType} />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <BestOfYoutube deviceType={deviceType} />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <SocialMedia deviceType={deviceType} />
      </Suspense>
      <Suspense fallback={<div />}>
        <ScrollToTop />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <Footer deviceType={deviceType} />
      </Suspense>
      <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
    </div>
    </CacheBuster>
  );
}
export default App;
